import { render, staticRenderFns } from "./SafeDigRegister.vue?vue&type=template&id=20cf8773&scoped=true"
import script from "./SafeDigRegister.vue?vue&type=script&lang=js"
export * from "./SafeDigRegister.vue?vue&type=script&lang=js"
import style0 from "./SafeDigRegister.vue?vue&type=style&index=0&id=20cf8773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf8773",
  null
  
)

export default component.exports